import React from "react";
import classes from "./CheckDetails.module.css";
import MenuUtils from "../../../../../util/menu-utils";
import classNames from "classnames";

const CheckItem = (props) => {
  const {
    item = {},
  } = props;

  const renderModifiers = (mod, index) => {
    if (mod) {
      const modText =
        mod.quantity > 1
          ? `- ${mod.quantity} x ${mod.modifierName}`
          : `- ${mod.modifierName}`;
      const modString = `${modText} ${
        mod.price > 0 ? `($ ${mod.price.toFixed(2)})` : ""
      }`;
      return (
        <span
          className={classes.checkCellView}
          style={{ paddingLeft: `${index * 1.5}vw`, width: "100%" }}
        >
          {modString}
        </span>
      );
    }
    return <span />;
  };

  const renderModifiersRecursively = (im) =>
    MenuUtils.renderModifiersRecursively(
      im,
      0,
      (i, index) => renderModifiers(i, index),
      (i) => {},
      true
    );

  const comment =
    item.quantity > 1 ? `\t\t\t - ${item.comment}` : ` - ${item.comment}`;

  return (
    <div className={item.pending ? classNames(
      `${classes.itemContainer}`,
      `${classes.pendingBg}`,
      ) : classNames(
        `${classes.itemContainer}`
      )}>
        <div className={classes.rowSpaceBetween}>
          <div className={classes.nameAndPrice}>
            <span className={classNames(`${classes.checkCellView}`, `${classes.name}`)}>
              {`${item.quantity > 1 ? `${item.quantity} x ` : ""}${
                item.menuItemName
              }`}
            </span>
            <span
              className={classNames(
                `${classes.checkCellView}`,
                `${classes.price}`
              )}
            >
              {`$${item && item.price && item.price.toFixed(2)}`}
            </span>
          </div>
          {item.modifiers ? renderModifiersRecursively(item) : null}
        </div>
        {item.comment ? (
          <span
            className={classNames(
              `${classes.checkCellView}`,
              `${classes.note}`
            )}
          >
            {comment}
          </span>
        ) : null}
    </div>
  );
};

const CheckItems = (props) => {
  const {
    items = [],
  } = props || {};

  const renderCheckItems = (item) => {
    return (
      <CheckItem
        key={`checkItem-${item.id}`}
        item={item}
      />
    );
  };

  return (
    <div className={classNames(`${classes.checkItemsContainer}`)}>
      {Array.isArray(items) && items.length
        ? items.map((item, itemIndex) => {
            return <div key={`menuItem-${itemIndex}`}>{renderCheckItems(item)}</div>;
          })
        : null}
    </div>
  );
};

export default CheckItems;
